export default ['text', { props: { marks: { type: 'array', items: ['link'], optional: true } } }];
